/* global YaGames */
import React, { useState, useEffect } from 'react';
import styles from './css_modules/GameRules.module.css'; // Импортируем стили
import generateBoard from "../business/boardGenerator"; // Импортируем функцию
import { useTranslation } from "react-i18next";
import LanguageSwitcher from './LanguageSwitcher';




const GameRules = ({ resetBoard }) => {
    const [isRulesOpen, setIsRulesOpen] = useState(false); // Попап с правилами
    const [isAdPopupOpen, setIsAdPopupOpen] = useState(false); // Попап с рекламой
    const [isCooldownActive, setIsCooldownActive] = useState(false); // Кулдаун
    const [cooldownTime, setCooldownTime] = useState(0); // Оставшееся время кулдауна в секундах
    const { t } = useTranslation();

    // Функции для открытия и закрытия попапа с правилами
    const openRulesPopup = () => setIsRulesOpen(true);
    const closeRulesPopup = () => setIsRulesOpen(false);

    // Функции для открытия и закрытия попапа с рекламой
    const openAdPopup = () => {
        if (!isCooldownActive) setIsAdPopupOpen(true); // Открыть только если кулдаун не активен
    };
    const closeAdPopup = () => setIsAdPopupOpen(false);

    // Функция для вызова рекламы и сброса доски
    const handleResetBoard = () => {
        closeAdPopup();
        resetBoard(generateBoard());
        startCooldown(); // Запуск кулдауна после сброса доски

        if (window.ysdk) {
            
      
            window.ysdk.adv.showRewardedVideo({
              callbacks: {
                onOpen: () => console.log("[YSDK] Ad opened."),
                onRewarded: () => console.log("[YSDK] ad reward."),
                onClose: () => console.log("[YSDK] go game."),
                onError: (e) => {
                  console.error("[YSDK] Ad error:", e);
                  
                },
              },
            });
          } else {
            console.error("Yandex SDK not initialized.");
          }
        };

        
  





    // Функция для запуска кулдауна
    const startCooldown = () => {
        setIsCooldownActive(true);
        setCooldownTime(120); // Устанавливаем кулдаун на 120 секунд
    };

    // Эффект для уменьшения оставшегося времени кулдауна
    useEffect(() => {
        let timer;
        if (isCooldownActive && cooldownTime > 0) {
            timer = setInterval(() => {
                setCooldownTime((prevTime) => prevTime - 1);
            }, 1000);
        } else if (cooldownTime === 0) {
            setIsCooldownActive(false); // Снять блокировку по завершении кулдауна
        }
        return () => clearInterval(timer); // Очищаем таймер при размонтировании
    }, [isCooldownActive, cooldownTime]);

    return (
        <div>
            {/* Кнопка для открытия попапа с правилами */}
            <button onClick={openRulesPopup} className={styles.openButton}>
            {t('menu')}
            </button>

            {/* Попап с правилами игры */}
            <div className={`${styles.popupOverlay} ${isRulesOpen ? styles.show : ''}`}>
                <div className={styles.popupContainer}>
                    <h2 className={styles.title}>{t('rulesGame')}</h2>
                    <div className={styles.rulesList}>
                        <h3>{t('rulesbasic')}</h3>
                        <ul>
                            <li>{t('rulesbasicLi1')}</li>
                            <li>{t('rulesbasicLi2')}</li>
                            <li>{t('rulesbasicLi3')}</li>
                            <li>{t('rulesbasicLi4')}</li>
                            <li>{t('rulesbasicLi5')}</li>
                        </ul>
                        <h3>{t('howToPlay')}</h3>
                        <ul>
                            <li>{t('howToPlayLi1')}</li>
                            <li>{t('howToPlayLi2')}</li>
                            <li>{t('howToPlayLi3')}</li>
                        </ul>
                    </div>
                    {/* Кнопка для закрытия попапа */}
                    <div style={{display:'flex', justifyContent:'center', }}><button onClick={closeRulesPopup} className={styles.closeButton}>
                    {t('close')}
                    </button></div>
                    <LanguageSwitcher className={styles.closeButton} />
                    
                    {/* Кнопка для открытия попапа с рекламой */}
                    <button 
                        onClick={openAdPopup} 
                        className={styles.closeButton} 
                        disabled={isCooldownActive} // Блокируем, если кулдаун активен
                    >
                        {isCooldownActive ? `${t('adTime')} ${cooldownTime} ` : `${t('adTimeReset')}`}
                    </button>

                    {/* Попап с рекламой */}
                    <div className={`${styles.popupOverlay} ${isAdPopupOpen ? styles.show : ''}`}>
                        <div className={styles.popupContainer}>
                            <h2 className={styles.title}>{t('resetBoard')}</h2>
                            <p>{t('resetBoardAd')}</p>
                            {/* Кнопка для вызова функции сброса доски */}
                            <button onClick={handleResetBoard} className={styles.closeButton}>
                            {t('watchAd')}
                            </button>
                            {/* Кнопка для закрытия попапа */}
                            <button onClick={closeAdPopup} className={styles.closeButton}>
                            {t('cancel')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GameRules;
